jQuery(document).ready(function ($) {
  // ACF enqueues assets for every registered block in the editor, so this file loads in
  // wp-admin even when the block is nowhere on the page. Swiper is only enqueued on the
  // front end (see 2024/inc/enqueue.php), so `new Swiper(...)` threw "Swiper is not
  // defined" here. Because this runs inside the jQuery ready queue, that exception
  // aborted every ready callback registered after it -- including ACF's Select2 setup,
  // which left post_object fields as bare <select>s that never loaded their options.
  if (typeof Swiper === "undefined") return;
  if (!document.querySelector(".cards-slider .swiper-container")) return;

  var swiper = new Swiper(".cards-slider .swiper-container", {
    slidesPerView: 3.8,
    spaceBetween: 16,
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true,
    },
    on: {
      touchMove: function () {
        $("body").addClass("swiper-is-swiping");
      },
      touchEnd: function () {
        setTimeout(function () {
          $("body").removeClass("swiper-is-swiping");
        }, 150);
      },
    },

    breakpoints: {
      1024: {
        slidesPerView: 3.8,
      },

      768: {
        slidesPerView: 2.2,
      },

      0: {
        slidesPerView: 1.2,
      },
    },
  });
});
